import { Controller } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";
import { FormularioPesquisaFacialProps } from "../types/mandado-facial.types";

export const FormularioPesquisaFacial: React.FC<
  FormularioPesquisaFacialProps
> = ({ onSubmit, onLimpar, onAbrirCaptura, loading, control }) => {
  return (
    <MUI.Grid
      component="form"
      alignItems="center"
      width={["100%", "100%", "100%", "80%", "60%"]}
      container
      spacing={1}
      onSubmit={onSubmit}
    >
      {/* Campo de Upload de Foto */}
      <MUI.Grid item xs={12} md={8} sm={8}>
        <Controller
          name="foto"
          control={control}
          render={({ field: { onChange, value } }) => (
            <MUI.Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                border: "2px dashed #ccc",
                borderRadius: "8px",
                padding: 2,
                backgroundColor: "#fafafa",
                "&:hover": {
                  borderColor: "#1976d2",
                  backgroundColor: "#f5f5f5",
                },
                cursor: "pointer",
              }}
              component="label"
            >
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  onChange(file);
                }}
                style={{ display: "none" }}
                disabled={loading}
              />
              <MUIcons.PhotoCamera
                sx={{
                  fontSize: 32,
                  color: value ? "#4caf50" : "#666",
                }}
              />
              <MUI.Box sx={{ flex: 1 }}>
                <MUI.Typography
                  variant="body1"
                  sx={{
                    fontWeight: value ? "bold" : "normal",
                    color: value ? "#4caf50" : "#666",
                  }}
                >
                  {value
                    ? value.name
                    : "Clique para escolher uma foto do computador"}
                </MUI.Typography>
                {!value && (
                  <MUI.Typography variant="caption" color="text.secondary">
                    Formatos aceitos: JPG, PNG, WEBP, GIF
                  </MUI.Typography>
                )}
                {value && (
                  <MUI.Typography variant="caption" color="success.main">
                    Arquivo selecionado: {(value.size / 1024 / 1024).toFixed(2)}{" "}
                    MB
                  </MUI.Typography>
                )}
              </MUI.Box>
              {value && (
                <MUI.IconButton
                  onClick={(e) => {
                    e.preventDefault();
                    onChange(null);
                  }}
                  size="small"
                  color="error"
                >
                  <MUIcons.Clear />
                </MUI.IconButton>
              )}
            </MUI.Box>
          )}
        />
      </MUI.Grid>

      {/* Botão Capturar Foto */}
      <MUI.Grid item xs={12} md={4} sm={4}>
        <MUI.Button
          fullWidth
          variant="outlined"
          color="info"
          onClick={onAbrirCaptura}
          disabled={loading}
          startIcon={<MUIcons.CameraAlt />}
        >
          <MUI.Typography
            variant="button"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            Capturar Foto
          </MUI.Typography>
        </MUI.Button>
      </MUI.Grid>

      {/* Botão Consultar */}
      <MUI.Grid item xs={12} md={4} sm={4}>
        <MUI.Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          disabled={loading}
          startIcon={<MUIcons.Search />}
        >
          <MUI.Typography
            variant="button"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            Consultar
          </MUI.Typography>
        </MUI.Button>
      </MUI.Grid>

      {/* Botão Limpar */}
      <MUI.Grid item xs={12} md={4} sm={4}>
        <MUI.Button
          fullWidth
          variant="outlined"
          color="secondary"
          onClick={onLimpar}
          disabled={loading}
          startIcon={<MUIcons.Clear />}
        >
          <MUI.Typography
            variant="button"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            Limpar resultado
          </MUI.Typography>
        </MUI.Button>
      </MUI.Grid>
    </MUI.Grid>
  );
};
